module.exports = __webpack_public_path__ + "static/media/bell.625ee642.png";